export default "__VITE_ASSET__HbYvVOl7__"